/*
  Fires `collection_card_clicked` when a shopper opens a product from a
  collection grid. Primary metric for the `collection-products-first` and
  `collection-card-ratings` tests.

  Loaded for EVERY collection visitor, not just a variant. Instrumenting one arm
  from inside that arm is the mistake atc-upsell-popup made: the same
  interaction was counted for control and silently dropped for variant-a, and
  every per-open number in that test was invalid for two weeks. The event has to
  come from a path both arms share.

  Order-level outcomes still come from Shopify. This answers "did they open a
  product", which is the thing a grid layout can actually move, and it is the
  only metric with enough traffic to resolve: order-scoped metrics on collection
  traffic need around 198,000 visitors an arm for a 10% change.
*/
(function () {
  'use strict';

  var FIRED = 'wbCardClickSent';

  function handle(event) {
    var card = event.target && event.target.closest && event.target.closest('product-card');
    if (!card) return;

    /*
      A card is a link wrapping the image and the title, plus a quick-add button
      and a favourite toggle that are not navigations. Only count a click that
      opens the product.
    */
    var link = event.target.closest('a.product-card__link');
    if (!link) return;

    /*
      Once per page view. The metric is the share of visitors who opened a
      product, so a shopper who clicks two cards is one conversion either way,
      and sending both only inflates the event count.
    */
    if (window[FIRED]) return;
    window[FIRED] = true;

    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish('collection_card_clicked', {
          collection: (window.location.pathname.match(/\/collections\/([^/?#]+)/) || [])[1] || 'unknown'
        });
      }
    } catch (e) {
      /* analytics must never block the navigation */
    }
  }

  function start() {
    if (!document.body || !document.body.classList.contains('template-collection')) return;
    /* Capture phase, because the click navigates and a bubbling listener on a
       replaced grid can miss it. */
    document.addEventListener('click', handle, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
